import FieldController from '../field.controller';

class YesNoFieldController extends FieldController {
  constructor($scope, $q, $translate, $log, $timeout) {
    "ngInject";
    super($scope, $q, $translate, $log, $timeout);

    // The active flag must be there to properly populate the options
    this._options = [
      { id: 't', name: 'YES', active: true },
      { id: 'f', name: 'NO', active: true },
    ];
  }

  $onInit() {
    super.$onInit();

    // Add the options in manually since they're defined above and aren't in the database
    this.field.options = this.options;

    const keysToTranslate = this.options.map(opt => opt.name);
    const translatePromises = keysToTranslate.map(key => this.$translate(key));
    return this.$q.all(translatePromises)
      .then(translations => {
        for (let idx = 0; idx < this.options.length; idx++) {
          this.options[idx].name = translations[idx];
        }
        this.$scope.filteredOptions = this.options;
      });
  }

  get options() {
    return this._options;
  }
}

export default YesNoFieldController;
